import { scrollTo } from './utils/functions.js';

function requireAll(r){
  r.keys().forEach(r);
}

// const pageHeader = document.querySelector('.lp25-site-wrapper .page-header');
// const lastLookItem = document.querySelector('.lp25-site-wrapper .looks__item:last-child');
// let lastLookItemY = 0;
const pageBody = document.querySelector('body');
const pageWrapper = document.querySelector('.lp25-page-wrapper');
let pageHeight = pageWrapper.offsetHeight;
const heroSection = pageWrapper.querySelector('.lp25-page-wrapper .hero-section');
let windowHeight = window.innerHeight;
let count = 0;
let st = window.scrollY;
const theme = document.querySelector('.lp25-page-wrapper .theme');

const handleResize = (e)=>{
  let vh = window.innerHeight * 0.01;
  let vw = pageWrapper.offsetWidth;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  document.documentElement.style.setProperty('--vw', `${vw}px`);
  // get x position of the footer
  // lastLookItemY = lastLookItem.getBoundingClientRect().top + window.scrollY;
  window.dispatchEvent(new Event('scroll'));
  windowHeight = window.innerHeight;
  heroSection.style.width = pageWrapper.offsetWidth + 'px';
  pageHeight = pageWrapper.offsetHeight;
}

// function to wrap word by word with span and keep the br tags 
function wrapWords() {
  const elements = document.querySelectorAll('.lp25-page-wrapper .look__image-text, .lp25-page-wrapper .big-banner__copy');

  elements.forEach(element => {
    const newNodes = [];

    element.childNodes.forEach(node => {
      if (node.nodeType === Node.TEXT_NODE) {
        // テキストノードを単語に分割してラップ
        const words = node.textContent.split(/(\s+)/);
        words.forEach(word => {
          if (word.trim() === '') {
            newNodes.push(document.createTextNode(word)); // 空白はそのまま
          } else {
            const outerSpan = document.createElement('span');
            outerSpan.className = 'word';

            const innerSpan = document.createElement('span');
            innerSpan.className = 'word-inner';
            innerSpan.textContent = word;

            outerSpan.appendChild(innerSpan);
            newNodes.push(outerSpan);
          }
        });
      } else if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'BR') {
        // <br>タグはそのまま
        newNodes.push(node.cloneNode());
      } else {
        // その他のノードは一旦そのまま複製して追加（必要なら拡張可能）
        newNodes.push(node.cloneNode(true));
      }
    });

    // 元の内容を削除し、新しく生成したノードを追加
    element.innerHTML = '';
    newNodes.forEach(newNode => element.appendChild(newNode));
  });
}


wrapWords();

window.addEventListener('load', handleResize);
window.addEventListener('resize', handleResize);


const prlxElems = document.querySelectorAll(".lp25-page-wrapper .hero-section picture, .lp25-page-wrapper .looks-section picture, .lp25-page-wrapper .prlx--fade, .lp25-page-wrapper .looks, .lp25-page-wrapper .big-banner__copy");

let prevRectTop = 0;
const handleScroll = () => {
  count = 0;
  prlxElems.forEach((prlxElem) => {

    const rect = prlxElem.getBoundingClientRect();

    if(rect.top < (windowHeight * 0.8) && !prlxElem.classList.contains("looks")) {  
              
      if(prevRectTop != rect.top){
        count = 0;
      }
      if(prlxElem.classList.contains("qued")){
        return;
      }
      timer(() => {
        prlxElem.classList.add("executed");
      }, 100 * count);

      prlxElem.classList.add("qued");
      
      count++;
      
      prevRectTop = rect.top;

    }

    if( prlxElem.classList.contains("looks")) {
      if(rect.top <= 0){
        theme.classList.add("fixed");
      } else {
        theme.classList.remove("fixed");
      }
    }


  });
};


const timer = (func, delay)=>{
  setTimeout(()=>{
    func();
  }, delay);
}

// Swiper.use([Autoplay, EffectCreative]);

function init() {
  pageWrapper.classList.remove("loaded");
  timer(() => {
    pageWrapper.classList.add("loaded");
  }, 1100); // 少し遅延させて適用

    
  handleScroll();

}

window.addEventListener("load", init);

window.addEventListener("scroll", handleScroll);



// trigger scroll event
window.dispatchEvent(new Event('scroll'));

// select a tag that contains # in href
const anchorLinks = document.querySelectorAll('.lp25-page-wrapper a[href^="#"]');

anchorLinks.forEach(link => {
  link.addEventListener('click', function(e) {
    e.preventDefault();
    const targetId = this.getAttribute('href').replace('#', '.');
    const targetElement = document.querySelector(targetId);
    const targetElementY = targetElement.getBoundingClientRect().top + window.scrollY;
    if (targetElement) {
      scrollTo({to: targetElementY, duration: 1000});
    }
  });
}
);





